<template>
    <kt-form-section class="mb-5 mt-3">
        <kt-row>
            <kt-col class="col-lg-4 col-md-4 col-sm-4">
                <kt-form-group>
                    <kt-form-label for="min_score_level_1">
                        {{ $t('customers_club.setting.level_1') }}
                    </kt-form-label>
                    <kt-form-control
                            type="number"
                            name="min_score_level_1"
                            id="min_score_level_1"
                            v-model="customers_club_setting.min_score_level_1"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col class="col-lg-4 col-md-4 col-sm-4">
                <kt-form-group>
                    <kt-form-label for="min_score_level_2">
                        {{ $t('customers_club.setting.level_2') }}
                    </kt-form-label>
                    <kt-form-control
                            type="number"
                            name="min_score_level_2"
                            id="min_score_level_2"
                            v-model="customers_club_setting.min_score_level_2"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col class="col-lg-4 col-md-4 col-sm-4">
                <kt-form-group>
                    <kt-form-label for="min_score_level_3">
                        {{ $t('customers_club.setting.level_3') }}
                    </kt-form-label>
                    <kt-form-control
                            type="number"
                            name="min_score_level_3"
                            id="min_score_level_3"
                            v-model="customers_club_setting.min_score_level_3"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>
</template>

<script>
export default {
    name: "min-score-level",
    props: {
        customers_club_setting: {
            required: true
        },
    },
}
</script>

<style scoped>

</style>